import { useLocalStorage } from 'usehooks-ts';

import { ROUND_LIST } from '../providers/TodaysCountryProvider';
import { getBonusRoundSeedName, useDailySeed } from './useDailySeed';
import { ChoiceStatus } from './useRoundState';

export const useRoundEmojis = (isArchive: boolean) => {
  const dailySeed = useDailySeed(isArchive);
  const bonusRoundsSeeds = ROUND_LIST.slice(1).map(
    (round) => `${dailySeed}-${getBonusRoundSeedName(round.seed)}`,
  );

  const [dailyChoicesShape] = useLocalStorage(bonusRoundsSeeds[0], {});
  const [dailyChoicesEmblem] = useLocalStorage(bonusRoundsSeeds[1], {});
  const [dailyChoicesCapitalFlag] = useLocalStorage(bonusRoundsSeeds[2], {});
  const [dailyChoicesBorderFlag] = useLocalStorage(bonusRoundsSeeds[3], {});
  const [dailyChoicesQuiz] = useLocalStorage(bonusRoundsSeeds[4], {});

  const combinedRoundsChoices = [
    { round: 'shape', values: dailyChoicesShape },
    { round: 'emblem', values: dailyChoicesEmblem },
    { round: 'capital-flags', values: dailyChoicesCapitalFlag },
    { round: 'border-flag', values: dailyChoicesBorderFlag },
    { round: 'quiz', values: dailyChoicesQuiz },
  ];

  const emojis = combinedRoundsChoices.reduce<string[]>(
    (emojiList, { round, values }) => {
      if (!values || Object.keys(values).length === 0) {
        return emojiList;
      }

      if (round === 'quiz') {
        const quizValues = Object.values(values) as {
          answer: ChoiceStatus;
        }[];

        quizValues.forEach((quiz, index) => {
          if (quiz?.answer === ChoiceStatus.CORRECT) {
            const emojiEntry = ROUND_LIST.find((entry) => entry.seed === round);
            if (emojiEntry && Array.isArray(emojiEntry.emojis)) {
              emojiList.push(emojiEntry.emojis[index]);
            }
          }
        });
      } else {
        const isCorrect = Object.values(values).some(
          (status) => status === ChoiceStatus.CORRECT,
        );

        if (isCorrect) {
          const emojiEntry = ROUND_LIST.find((entry) => entry.seed === round);
          if (emojiEntry) {
            if (Array.isArray(emojiEntry.emojis)) {
              emojiList.push(...emojiEntry.emojis);
            } else {
              emojiList.push(emojiEntry.emojis);
            }
          }
        }
      }

      return emojiList;
    },
    [],
  );

  return emojis.join('');
};
